export enum InsertOrderErrorCodeEnum {
    NoError = 0,
    IsFraudError = 9,
}